import { AppState } from "../store";

export const getAppDttm = (state: AppState) => state.ui.appDttm
export const getAppCategory = (state: AppState) => state.ui.appCategory
